import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Radium } from 'higher-order-components'
import { flatMap, toPairs } from 'utils'

/** Flexbox Content Component. */
class GlobalNavItemGrid extends Component {
  constructor() {
    super()
    this.state = {
      active: -1,
      clickedIndex: -1
    }
  }
  componentDidMount() {
    if (this.props.nav) {
      setTimeout(() => {
        styles.hide.display = 'none'
      }, 100)
    }
  }
  componentWillUnmount() {
    if (this.props.nav) styles.hide.display = 'flex'
  }
  /**
   * @param {number} index - Index to set active
   */
  activate = (index) => {
    this.setState({ active: index })
  }
  reset = () => {
    this.setState({ active: -1 })
  }
  onClick = (index) => {
    this.setState({ clickedIndex: index })
  }
  isNav = () => {
    if (this.props.nav) {
      if (this.props.active && this.props.subNav) return styles.subNavShow
      if (this.props.active) return styles.show
      return styles.hide
    } return styles.show
  }
  childProps = (index) => {
    const faded = this.props.fadeItems
      ? (this.state.active === index || this.state.active === index || this.state.clickedIndex === index)
      : false
    const columns = this.props.columns || 3
    return {
      faded,
      key: index,
      flexBasis: 100 / columns,
      animationDelay: index * 0.1,
      subNav: this.props.subNav,
      centerContent: this.props.centerContent === undefined && (this.props.nav || this.props.subNav) ? true : this.props.centerContent,
      activate: this.activate.bind(this, index),
      reset: this.reset.bind(this, index),
      onClick: () => {
        !this.props.children[index].props.onClick && this.onClick(index)
        this.props.children[index].props.onClick && this.props.children[index].props.onClick()
      },
      loading: this.state.clickedIndex === index,
      active: this.props.active
    }
  }
  /**
   * @param {Boolean} [centerContent] - Center align content vertically
   * @param {Array|FlexIconLink} [components] - Nested Components
   * @param {Number} [columns=3] - Number of elements displayed horizontally.
   * @param {String} [backgroundColor='transparent'] - Background Color Hex Code.
   * @returns {ReactElement} React Component
   */
  render() {
    const { nav, subNav, children, backgroundColor } = this.props
    const centerContent =
      this.props.centerContent === undefined && (nav || subNav) ? true : this.props.centerContent

    // JIRA ticket MR-3165 had center-justified flex content clipped by container bounds.
    // Get around this by using margin auto on first and last children. Since we don't know which
    // components children will be comprised of (i.e. don't know if they allow style overrides,
    // how they size within a parent, etc), inject dummy divs to start and end of list
    return (
      <div
        data-test="flex-content"
        style={[
          styles.base,
          this.isNav(),
          backgroundColor && {
            backgroundColor: backgroundColor
          },
          centerContent && {
            "@media (min-width: 900px)": {
              maxWidth: '1200px',
              margin: '0 auto'
            }
          },
          subNav && styles.subNav
        ]}>
        {flatMap(([index, component]) => {
          if (index === 0 && centerContent) {
            return [<li style={styles.centerFirst} key={index - 1} />, component]
          }

          if (index === children.length - 1 && centerContent) {
            return [component, <li style={styles.centerLast} key={index + 1} />]
          }

          return component
        }, toPairs(children.map((comp, index) => React.cloneElement(comp, this.childProps(index)))))}
      </div>
    )
  }
}

GlobalNavItemGrid.defaultProps = {
  fadeItems: true
}

GlobalNavItemGrid.propTypes = {
  children: PropTypes.node,
  fadeItems: PropTypes.bool,
  subNav: PropTypes.bool,
  columns: PropTypes.number,
  active: PropTypes.bool,
  nav: PropTypes.bool,
  backgroundColor: PropTypes.string,
  centerContent: PropTypes.bool
}

export default Radium(GlobalNavItemGrid)

const styles = {
  base: {
    width: '100%',
    boxSizing: 'border-box',
    flexWrap: 'wrap',
    padding: '1em 0 4em'
  },
  show: {
    display: 'flex'
  },
  hide: {
    display: 'flex'
  },
  subNav: {
    flexDirection: 'column'
  },
  subNavShow: {
    display: 'block'
  },
  centerFirst: {
    margin: 'auto 0 0 0',
    padding: 0,
    width: '100%'
  },
  centerLast: {
    margin: '0 0 auto 0',
    padding: 0,
    width: '100%'
  }
}



// WEBPACK FOOTER //
// ./src/components/global-nav-item-grid/index.jsx